import React from 'react';
import {Button} from 'antd';

/** Компонента отображения загрузки данных  */
export const LoadingComponent = () => (
  <div style={{ textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px',}}>
    <Button shape="circle" loading />
  </div>
);

/** Компонента отображения сообщения об ошибка  */
export const ErrorMessageComponent = error => (
  <div style={{ textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px', color: "red"}}>
    Ошибка: {error}
  </div>
)